import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('versionAvailabilityBanner');

    return {
        SUB: t('sub'),
        TITLE: t('title'),
        TRY_IT_NOW: t('tryItNow')
    };
};

export default useTranslation;
